/** @jsx jsx */
import { useState } from "react"
import { Flex, Spinner, jsx } from "theme-ui"
import { Arrow } from "../svg"

function Input({ type, placeholder, loading, handleSubmit, styles = {} }) {
  const [value, setValue] = useState("")

  return (
    <Flex
      as="form"
      onSubmit={e => {
        e.preventDefault()
        handleSubmit(value)
      }}
      sx={{
        marginTop: "1em",
        fontSize: "18px",
        maxWidth: "570px",
        flexDirection: "row",
        paddingBottom: "0.5em",
        borderBottom: "1px solid #333333",
        ...styles,
      }}
    >
      <input
        sx={{
          fontFamily: "secondary",
          width: "100%",
          border: "none",
          background: "transparent",
        }}
        placeholder={placeholder}
        onChange={e => setValue(e.target.value)}
        value={value}
        type={type}
      />
      <button
        sx={{
          border: "none",
          background: "transparent",
          svg: {
            marginTop: "5px",
          },
        }}
        type="submit"
      >
        {loading ? (
          <Spinner sx={{ color: "#333" }} size={18} strokeWidth={3} />
        ) : (
          <Arrow color={"#333"} />
        )}
      </button>
    </Flex>
  )
}

export default Input
